export default {
  name: "cmsFooter"
};